<template>
  <div class="order-group">
    <fixed-tab>
      <van-tabs
        slot="content"
        :line-width="16"
        :line-height="2"
        v-model="curTab"
        @change="onTabChange"
      >
        <van-tab v-for="(item, index) in tabs" :key="index" :title="item.name" :name="item.id"></van-tab>
      </van-tabs>
    </fixed-tab>
    <Empty v-if="!list.length" :empty_type="{ name: '暂无订单' }"></Empty>
    <List
      ref="list"
      url="/api/app/mySpellGroup/order"
      method="get"
      :params="params"
      :on-getdata="onGetdata"
      :showText="list.length > 0"
    >
      <OrderList slot="item" :list="list" :orderType="5" @onReset="onReset" @onComment="onComment"></OrderList>
    </List>
    <Evaluating ref="comment" @refresh="onReset" com_type="3"></Evaluating>
  </div>
</template>

<script>
import Empty from "@/components/Empty";
import List from "@/components/List";
import OrderList from "./OrderList";
import Evaluating from "@/components/Evaluating";
export default {
  name: "order-group",
  components: {
    Empty,
    List,
    OrderList,
    Evaluating
  },
  data() {
    return {
      tabs: [
        { id: 0, name: "全部订单" },
        { id: 1, name: "待支付" },
        { id: 2, name: "拼团中" },
        { id: 3, name: "待发货" },
        { id: 4, name: "已发货" },
        { id: 5, name: "交易完成" }
      ],
      curTab: +this.$route.query.tab || 0,
      params: {
        order_status: 0,
        pay_status: undefined,
        ship_status: undefined,
        group_status: undefined
      },
      list: []
    };
  },
  created() {
    this.setParams();
  },
  methods: {
    // on event
    onTabChange() {
      this.setParams();
      this.$refs.list.reset();
    },
    onGetdata(data) {
      this.list = data;
    },
    onReset() {
      this.$refs.list.reset();
    },
    onComment(item) {
      this.$refs.comment.showBox({
        id: item.shop_ids,
        order_number: item.order_number
      });
    },
    // other
    setParams() {
      switch (this.curTab) {
        case 0:
          this.params.order_status = 0;
          this.params.pay_status = undefined;
          this.params.ship_status = undefined;
          this.params.group_status = undefined;
          break;
        case 1:
          this.params.order_status = 1;
          this.params.pay_status = 1;
          this.params.ship_status = undefined;
          this.params.group_status = undefined;
          break;
        case 2:
          this.params.order_status = 1;
          this.params.pay_status = 2;
          this.params.ship_status = undefined;
          this.params.group_status = 2;
          break;
        case 3:
          this.params.order_status = 1;
          this.params.pay_status = 2;
          this.params.ship_status = 1;
          this.params.group_status = 1;
          break;
        case 4:
          this.params.order_status = 1;
          this.params.pay_status = 2;
          this.params.ship_status = 3;
          this.params.group_status = 1;
          break;
        case 5:
          this.params.order_status = 2;
          this.params.pay_status = undefined;
          this.params.ship_status = undefined;
          this.params.group_status = undefined;
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
